import React, { useState } from 'react';
import {
  LocalHotel
} from "@mui/icons-material";
import {
  Tooltip, 
} from "@mui/material";

import { 
  Character, 
} from "@dndModels";

import CharacterRest from "@dndComponents/character/misc/CharacterRest";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  char: Character;
}

export default function CharacterRestButton({
  char,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open ?
          <CharacterRest 
            char={char}
          />
          : <></>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title="Take a Rest">
        <LocalHotel
          className="clickable"
          onClick={() => {
            setOpen(true);
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}

